import type { ReactNode } from 'react';

export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="starfield flex min-h-dvh items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <p className="text-center text-2xl font-semibold tracking-[0.2em] text-info uppercase">
          Stars &amp; Ships
        </p>
        <section className="mt-6 hud-cut-sm border border-line bg-panel/90 p-6 shadow-2xl shadow-black/50">
          <h1 className="font-display text-xl font-bold uppercase tracking-[0.08em] text-text">
            {title}
          </h1>
          <div className="mt-4 space-y-4">{children}</div>
        </section>
      </div>
    </main>
  );
}
